module.exports = __webpack_public_path__ + "img/Slide34.0f73908a.png";